import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage"; // To Upload Files and Images to Storage and Get URL

import { app } from "./init";

const storage = getStorage(app);

function uploadFile(file, contentType, collection, onProgress, onUploaded) {
  // Create the file metadata
  /** @type {any} */

  const metadata = {
    contentType: contentType,
  };
  // Upload file and metadata to the object 'images/mountains.jpg'
  const storageRef = ref(
    storage,
    collection + "/" + new Date().getTime().toString() + file.name
  );
  const uploadTask = uploadBytesResumable(storageRef, file, metadata);
  // Listen for state changes, errors, and completion of the upload.
  uploadTask.on(
    "state_changed",
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      // this.uploadProgress = progress;
      onProgress(progress);
    },
    (error) => {
      console.log("Error uploading: ", error);
    },
    () => {
      // Upload completed successfully, now we can get the download URL
      getDownloadURL(uploadTask.snapshot.ref)
        .then((downloadURL) => {
          // this.addCategory(this.category);
          onUploaded(downloadURL);
        })
        .then(() => {});
    }
  );
}

function deleteFileFromUrl(url) {
  if (url === "" || url.isEmpty) return;
  const object = ref(storage, url);
  deleteObject(object);
}

export { deleteFileFromUrl, uploadFile };
